import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-tab tab-content"},[_c('div',{staticClass:"resize-wrapper"},[_c('VueDraggableResizable',{attrs:{"draggable":false,"active":true,"prevent-deactivation":true,"w":204,"minWidth":90,"handles":['mr'],"axis":"x"}},[_c('nav',[_c(VSkeletonLoader,{attrs:{"type":"button@5"}})],1)])],1),_c('div',{staticClass:"content"},[_c(VSkeletonLoader,{attrs:{"type":"article"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }